/*
Author  : I.CUBE, inc.
main jQuery widget of Fpmini
*/

define('planetsports',[
    'jquery',
    'jquery/ui',
    'mage/translate',
    'Born_WeltPixelGtm/js/born_gtm',
    'Magento_Customer/js/customer-data',
    'owl_carousel',
    'slick',
    'fancybox'
], function ($, ui, _responsive, born_gtm,customerData) {
    'use strict';

    $.widget('planetsports.planetsports', {

        _create: function () {
            this.initAllPages();
        },

        initAllPages: function () {
            $(window).on('clear.wishlist', function () {
                var sections = ['wishlist'];
                customerData.invalidate(sections);
                customerData.reload(sections, true);
            });

            /*PMC-1341 - FIXED - On checkout observed same address two times*/
            /*PMC-1504 - minicart is not empty after placing order with kredivo*/
            if ($('body').hasClass("checkout-onepage-success")) {
                var sections = ['checkout-data', 'cart'];
                customerData.invalidate(sections);
                customerData.reload(sections, true);
            }

            // ----move header links to nav section----
            $('.page-wrapper > .header.links').appendTo(".page-wrapper .sections.nav-sections .section-items");
            $('.page-wrapper .sections.nav-sections .section-items .header.links').css("display", "block");
            // ----move header links to nav section----

            if ($(window).width() > 767) {
                $(".l4-menu.feature-mobile").remove();
            }
            else{
                $(".l4-menu.feature-desktop").remove();
            }
            if ($(window).width() < 768) {
                $('.mobile-sort-by .item:first-child').addClass('active');
            }
            $('body').on('click', '.mobile-sort-by li', function () {
                var value = $(this).data('value');
                $('.sorter-options:first').val(value).trigger('change');
                $('#sorter_mobile').find('[data-role="title"]').click(function() {
                    return false;
                });
            });
            $('.page-with-filter.catalogsearch-result-index .message').insertAfter('.page-with-filter.catalogsearch-result-index .page-title-wrapper');

            // ----move copyright below newsletter----
            if ($(window).width() > 639) {
                $('.page-wrapper .copyright').appendTo(".footer-container .right > .newsletter > div > .copyright");
            }
            // ----move copyright below newsletter----
            // ---- Top Search Toggle in Mobile  ----
            // ---- Top Search Toggle in Mobile  ----
            // ---- Change tel fields to Number ----
            jQuery("#telephone").prop("type", "number");
            jQuery("[name='telephone']").prop("type", "number");

            // ---Hamburger-close toggle ---
            $(".hamburger-close").click(function () {
                $(".sections.nav-sections").removeClass("Level1");
                $(".sections.nav-sections").removeClass("Level2");
                $('.header-flyout__container.level-3').removeClass('link-shown');
                $(".level0").removeClass('c-selected');
                $('html').removeClass('nav-before-open nav-open');
                $('.header-flyout__container.level-3').removeClass('link-shown');
                $('.get-help').removeClass('get-help-link-shown');

            });

            // drilldown arrow js

            $(document).ready(function() {
                var drillOpener = $('<span class="drill-opener"></span>');
                $('.opener').after(drillOpener);
                var featured = $('.recomendation-slider-homepage .widget-product-grid');
                featured.owlCarousel({
                    items: 5,
                    stagePadding: 50,
                    slideSpeed: 800,
                    nav: false,
                    dots: false,
                    autoplay: false,
                    loop: false,
                    smartSpeed: 1500,
                    responsive: {
                        // breakpoint from 0 up
                        0: {
                            items: 1,
                            nav: false,
                            dots: false
                        },
                        // breakpoint from 480 up
                        480: {
                            items: 2,
                            nav: false,
                            dots: false
                        },
                        // breakpoint from 768 up
                        768: {
                            items: 4,
                            nav: true,
                            dots: false
                        },
                        // breakpoint from 768 up
                        940: {
                            items: 5,
                            nav: true,
                            dots: false
                        }
                    }
                });
              });

            // --- search popup toggle ---
            $(document).ready(function () {

                setTimeout(function() {
                    $('.slider-loader').css({"opacity": "0"});
                }, 200);
                setTimeout(function() {
                    $('.slider-loader').css({"display": "none"});
                }, 1500);
                window.onload = function() {
                    $('.product_image .product-image-photo.lazy').css({"opacity": "1"});
                };

                $(document).on('touchend click', '.search_pop .open', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    var interval = setInterval(function () {
                        if ($('input.aa-Input').length) {
                            $('input.aa-Input').trigger('click').trigger('focus');
                            clearInterval(interval);

                        }
                    }, 150);
                    if ($(this).hasClass("active")) {
                        if ($(e.target).closest('.search_pop').length) {
                            $(".popup-overlay, .popup-content, .open, .search_pop").removeClass("active");
                            $(".aa-Panel").hide();
                        }

                    }else{
                        $(".popup-overlay, .popup-content, .open, .search_pop").addClass("active");
                        $(".aa-Panel").show();
                    }

                    if ($(".popup-overlay").hasClass("active")) {
                        $('body').css('overflow', 'hidden');
                    } else {
                        $('body').css('overflow', 'visible');
                    }
                });
                $(".page-header").click(function(e){
                    //e.stopPropagation()
                    if ($(".popup-overlay").hasClass("active")) {

                    }
                });
                $(document).on('click touchend', function(event) {
                        if (!$(event.target).closest('.search_pop').length &&
                            !$(event.target).closest('.productColumn2').length) {
                            $(".popup-overlay, .popup-content, .open, .search_pop").removeClass("active");
                            $('body').css('overflow', 'visible');
                            $(".aa-Panel").hide();
                        }
                });

                $(".nav-item.dropdown").hover(function() {
                    $(".popup-overlay, .popup-content, .open, .search_pop").removeClass("active");
                    $('body').css('overflow', 'visible');
                    $(".aa-Panel").hide();
                });

                $(document).on('touchstart', '.minisearch button.search', function (e) {
                    document.location.href = $('#search_mini_form').attr('action')+'?q='+
                        $('.aa-Autocomplete .aa-Input').val();
                });

                $('#search_mini_form').submit(function(e){
                    var actionPath = $('#search_mini_form').attr('action')+'?q='+
                        $('.aa-Autocomplete .aa-Input').val();
                    document.location.href = actionPath;
                    e.preventDefault();
                });

                // $(".left").on("click", function () {
                //     $(".popup-overlay, .popup-content, .open, .search_pop").removeClass("active");
                //     $('body').css('overflow', 'visible');
                // });

                $(document).on('change', "[id^='cart']", function () {
                    $("#form-validate").submit();
                });
            });
            //homepage hover on new arrivals

            $(".new-arrivals-section--desktop .home-sub-col, .shop-trending-section--desktop .home-sub-col a").hover(
                function () {
                    $(this).children('.hover-class').addClass("hover");
                },
                function () {
                    $(this).children('.hover-class').removeClass("hover");
                }
            );
            // showing the search searchSuggestions into differnt DIV

            $('#searchSuggestions').appendTo('#search_block');

            // ---- header slider carousel ----
            $('.owl-carousel').owlCarousel({
                loop: true,
                margin: 10,
                dots: false,
                nav: true,
                mouseDrag: false,
                items: 1,
                singleItem: true,
                autoplay: true,
                responsive: false,
            });

            $(".regular").not('.slick-initialized').slick({
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                adaptiveHeight: false,
                rows: 1,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: false,
                responsive: [{
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        vertical: false,
                    },
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        rows: 1,
                        vertical: false,
                    },
                }]
            });
            $('.slider-class').slick('unslick').slick();

            // ---- mobile menu click
            $('.top-menu.nav-mobile *').click(function () {
                var interval = setInterval(function () {
                    if ($('.top-menu.nav-mobile .navigation').hasClass("loaded")) {
                        if ($('.top-menu.nav-mobile .navigation > .dropdown-menu').length) {
                            $('.top-menu.nav-mobile').css({ 'min-height': 'auto' });
                            $('.sections.nav-sections .additional-mobile').show();
                            $('.sections.nav-sections .additional-login-mobile').hide();
                            $('.sections.nav-sections #multistore-mobile-switcher-language').show();
                            $('.sections.nav-sections .store-information').show();
                            clearInterval(interval);
                        } else {
                            $('.sections.nav-sections .additional-mobile').show();
                            $('.sections.nav-sections #multistore-mobile-switcher-language').show();
                            $('.sections.nav-sections .store-information').show();
                            $('.top-menu.nav-mobile').css({ 'min-height': 'auto' });
                            if ($(".responsive-main-header .header.links > .customer-welcome").length) {
                                $('.sections.nav-sections .additional-login-mobile').show();
                            }
                            clearInterval(interval);
                        }
                    }
                }, 50);
            });
            //--- Topmenu phtml js code updated
            if ($(window).width() > 767) {
                $(document).on('click', '.nav-item > .nav-anchor', function (e) {
                    //e.stopPropagation();
                    if ($(this).hasClass("actived")) {
                        $(".submenu.dropdown-menu").addClass('trans_menu');
                        // if ($(window).width() < 768) {
                            return true;
                        // }
                        var obj = $(this).parents(".nav-item").eq(0);
                        // if ($(obj).children('.submenu').length > 0 && !$(obj).hasClass("subgroup")) {
                        //     e.preventDefault();
                        //     $(this).removeClass("actived");
                        //     if ($(obj).hasClass('current')) {
                        //         $(obj).removeClass('current');
                        //     }
                        //     if ($(obj).data('caret')) {
                        //         $(obj).children('.nav-anchor').find('.ves-caret').removeClass($(obj).data('hovercaret')).addClass($(obj).data('caret'));
                        //     }
                        //
                        //     var container = $(" .nav-item.level0.current");
                        //     var container1 = $(" .nav-item.level1.current");
                        //     var container2 = $(" .nav-item.level2.current");
                        //     var container3 = $(" .nav-item.level3.current");
                        //     // if the target of the click isn't the container nor a descendant of the container
                        //
                        //     if (!container.is(e.target) && container.has(e.target).length === 0) {
                        //         $(container).removeClass('current');
                        //         return false;
                        //     }
                        //     if (!container1.is(e.target) && container1.has(e.target).length === 0) {
                        //         $(container1).removeClass('current');
                        //         return false;
                        //     }
                        //     if (!container2.is(e.target) && container2.has(e.target).length === 0) {
                        //         $(container2).removeClass('current');
                        //         return false;
                        //     }
                        //     if (!container3.is(e.target) && container3.has(e.target).length === 0) {
                        //         $(container3).removeClass('current');
                        //         return false;
                        //     }
                        //     return false;
                        // }
                    } else {
                        // var obj = $(this).parents(".nav-item").eq(0);
                        // if ($(obj).children('.submenu').length > 0 && !$(obj).hasClass("subgroup")) {
                        //     if ($(obj).hasClass('level0')) {
                        //         $(' > .nav-item').removeClass('current');
                        //     }
                        //     if ($(obj).hasClass('current')) {
                        //         $(obj).removeClass('current');
                        //         $(".submenu.dropdown-menu").addClass('trans_menu');
                        //     } else {
                        //         $(obj).addClass('current');
                        //         $(this).addClass("actived");
                        //         $(".submenu.dropdown-menu").removeClass('trans_menu');
                        //     }
                        //
                        //     if ($(obj).data('hovericon')) {
                        //         $(obj).children('.nav-anchor').find('.item-icon').attr('src', $(obj).data('hovericon'));
                        //     }
                        //     if ($(obj).data('caret') && $(obj).data('hovercaret')) {
                        //         $(obj).children('.nav-anchor').find('.ves-caret').removeClass($(obj).data('caret')).addClass($(obj).data('hovercaret'));
                        //     }
                        //
                        //     return false;
                        //}
                    }
                });
                $(document).on({
                    mouseenter: function () {
                        $(this).siblings().addClass("hover-dark-transition");
                    },
                    mouseleave: function () {
                        $(this).siblings().removeClass("hover-dark-transition");
                    }
                }, 'li.nav-item.level0');
            }
            if ($(window).width() < 767) {
                $(document).on('click', '.nav-item > .nav-anchor', function (e) {
                    if ($(this).hasClass("nav-anchor")) {
                        // if ($(window).width() < 768) {
                            return true;
                      //  }
                        var obj = $(this).parents(".nav-item").eq(0);
                        // if ($(obj).children('.submenu').length > 0 && !$(obj).hasClass("subgroup")) {
                        //     e.preventDefault();
                        //     //$(this).removeClass("actived");
                        //     // if ($(obj).hasClass('current')) {
                        //     //     $(obj).removeClass('current');
                        //     // }
                        //     // if ($(obj).data('caret')) {
                        //     //     $(obj).children('.nav-anchor').find('.ves-caret').removeClass($(obj).data('hovercaret')).addClass($(obj).data('caret'));
                        //     // }
                        //
                        //     var container = $(" .nav-item.level0.current");
                        //     var container1 = $(" .nav-item.level1.current");
                        //     var container2 = $(" .nav-item.level2.current");
                        //     var container3 = $(" .nav-item.level3.current");
                        //     // if the target of the click isn't the container nor a descendant of the container
                        //
                        //     if (!container.is(e.target) && container.has(e.target).length === 0) {
                        //         $(container).removeClass('current');
                        //         return false;
                        //     }
                        //     if (!container1.is(e.target) && container1.has(e.target).length === 0) {
                        //         $(container1).removeClass('current');
                        //         return false;
                        //     }
                        //     if (!container2.is(e.target) && container2.has(e.target).length === 0) {
                        //         $(container2).removeClass('current');
                        //         return false;
                        //     }
                        //     if (!container3.is(e.target) && container3.has(e.target).length === 0) {
                        //         $(container3).removeClass('current');
                        //         return false;
                        //     }
                        //     return false;
                        // }
                    } else {
                        // var obj = $(this).parents(".nav-item").eq(0);
                        // if ($(obj).children('.submenu').length > 0 && !$(obj).hasClass("subgroup")) {
                        //     if ($(obj).hasClass('level0')) {
                        //         $(' > .nav-item').removeClass('current');
                        //     }
                        //     if ($(obj).hasClass('current')) {
                        //         $(obj).removeClass('current');
                        //     } else {
                        //         $(obj).addClass('current');
                        //         $(this).addClass("actived");
                        //     }
                        //
                        //     if ($(obj).data('hovericon')) {
                        //         $(obj).children('.nav-anchor').find('.item-icon').attr('src', $(obj).data('hovericon'));
                        //     }
                        //     if ($(obj).data('caret') && $(obj).data('hovercaret')) {
                        //         $(obj).children('.nav-anchor').find('.ves-caret').removeClass($(obj).data('caret')).addClass($(obj).data('hovercaret'));
                        //     }
                        //
                        //     return false;
                        // }
                    }
                });
            }

            // $(document).on('click', '.menu_close', function () {
            //     $(".nav-item.ui-menu-item").removeClass("current");
            // });
            $(document).ready(function () {
                $("button.btn-success-payment").on('click', function () {
                    $("#copyToClipboard").html("Copied");
                });
            });

            $.noConflict();
            $(document).ready(function ($) {
                if ($('body').hasClass("checkout-index-index") && $('body').hasClass("store-view-en_sg")) {
                    var checkoutIntervalRegion = setInterval(function () {
                        if ($('#shipping-new-address-form').find('select[name="region_id"] option').length > 1) {
                            $('#shipping-new-address-form').find('select[name="region_id"] option:last').attr('selected','selected');
                            $('#shipping-new-address-form').find('select[name="region_id"]').trigger('change');
                            $('#shipping-new-address-form').find('select[name="region_id"] option:last').prop('selected', true);
                            $('#shipping-new-address-form').find('select[name="region_id"]').attr('readonly',true);
                            clearInterval(checkoutIntervalRegion);
                        }
                    }, 100);
                    var checkoutIntervalCity = setInterval(function () {
                        if ($('#shipping-new-address-form').find('select[name="custom_attributes[city_id]"] option').length > 1) {
                            $('#shipping-new-address-form').find('select[name="custom_attributes[city_id]"] option:last').attr('selected','selected');
                            $('#shipping-new-address-form').find('select[name="custom_attributes[city_id]"]').trigger('change');
                            $('#shipping-new-address-form').find('select[name="custom_attributes[city_id]"] option:last').prop('selected', true);
                            $('#shipping-new-address-form').find('select[name="custom_attributes[city_id]"]').attr('readonly',true);
                            var lastOptVal = $('#shipping-new-address-form').find('select[name="custom_attributes[city_id]"] option:last').val();
                            $('#shipping-new-address-form').find('input[name="city"]').val(lastOptVal);
                            clearInterval(checkoutIntervalCity);
                        }
                    }, 100);
                    var checkoutIntervalKecamatan = setInterval(function () {
                        if ($('#shipping-new-address-form').find('select[name="custom_attributes[district_id]"] option').length > 1) {
                            $('#shipping-new-address-form').find('select[name="custom_attributes[district_id]"] option:last').attr('selected','selected');
                            $('#shipping-new-address-form').find('select[name="custom_attributes[district_id]"]').trigger('change');
                            $('#shipping-new-address-form').find('select[name="custom_attributes[district_id]"] option:last').prop('selected', true);
                            $('#shipping-new-address-form').find('select[name="custom_attributes[district_id]"]').attr('readonly',true);
                            clearInterval(checkoutIntervalKecamatan);
                        }
                    }, 100);
                }

                if (($('body').hasClass("customer-address-form") || $('body').hasClass("customer-endlessaisle-register")) && $('body').hasClass("store-view-en_sg")) {

                    if ($('body').hasClass("customer-address-form")) {
                        var $form = $('.form-address-edit');
                    } else if ($('body').hasClass("customer-endlessaisle-register")) {
                        var $form = $('#form-create-account-new')
                    }
                    if ($form) {
                        var initIntervalRegion = setInterval(function () {
                            if ($form.find('select[name="region_id"] option').length > 1) {
                                $form.find('select[name="region_id"] option:last').attr('selected','selected');
                                $form.find('select[name="region_id"]').trigger('change');
                                $form.find('select[name="region_id"] option:last').prop('selected', true);
                                $form.find('select[name="region_id"]').attr('readonly',true);
                                clearInterval(initIntervalRegion);
                            }
                        }, 100);
                        var initIntervalCity = setInterval(function () {
                            if ($form.find('select[name="cityCopy"] option').length > 1) {
                                $form.find('select[name="cityCopy"] option:last').attr('selected','selected');
                                $form.find('select[name="cityCopy"]').trigger('change');
                                $form.find('select[name="cityCopy"] option:last').prop('selected', true);
                                $form.find('select[name="cityCopy"]').attr('readonly',true);
                                var lastOptVal = $form.find('select[name="cityCopy"] option:last').val();
                                $form.find('input[name="city"]').val(lastOptVal);
                                clearInterval(initIntervalCity);
                            }
                        }, 100);
                        var initIntervalKecamatan = setInterval(function () {
                            if ($form.find('select[name="kecamatan"] option').length > 1) {
                                $form.find('select[name="kecamatan"] option:last').attr('selected','selected');
                                $form.find('select[name="kecamatan"]').trigger('change');
                                $form.find('select[name="kecamatan"] option:last').prop('selected', true);
                                $form.find('select[name="kecamatan"]').attr('readonly',true);
                                clearInterval(initIntervalKecamatan);
                            }
                        }, 100);
                    }
                }
            });

            if (!$('body').hasClass("checkout-index-index")) {
                var stickyTop = ($('.header-main').offset() || { "top": NaN }).top;
                $(window).on('scroll', function () {
                    if ($(window).scrollTop() >= stickyTop) {
                        $('.header-main').css({ position: "fixed", top: "0px", width: "100%" });
                        $('body').addClass("stickyHeader");
                        if ($(window).width() < 767) {
                            $('.page-wrapper').css({ 'margin-top': "50px"});
                        }
                    } else {
                        $('.header-main').css({ position: "relative", top: "0px" });
                        $('body').removeClass("stickyHeader");
                        if ($(window).width() < 767) {
                            $('.page-wrapper').css({ 'margin-top': "0px"});
                        }
                    }
                });
            }

            function stickHeight() {
                if ($(window).width() > 1024) {
                    var h = $('header.page-header').height();
                } else {
                    var h = $('.header-main').height();
                }
                $('.scroll-div').height(h);
            }
            stickHeight();
            $(window).resize(function () {
                stickHeight();
            });

            $(document).ready(function () {
                $('.promo-trigger.toggle').click(function (e) {
                    e.preventDefault();
                    $('.promocode-accordion').toggleClass('active');
                    $('#block-discount .content').slideToggle("active");
                });
                $('.promo-trigger.eds-toggle').click(function (e) {
                    e.preventDefault();
                    $('.promocode-eds-accordion').toggleClass('active');
                    $('#block-eds-discount .content').slideToggle("active");
                });
                $('.checkout-cart-index .eds-discount-trigger').click(function(e){
                    e.preventDefault();
                    $('.checkout-cart-index #block-eds-discount').toggleClass('active');
                    $('.checkout-cart-index #block-eds-discount .content').slideToggle("active");
                });
                if ($(window).width() < 767) {
                    var width = $(window).width() - 188;
                    $('.cart.item.message.error div').css('width', 'max-content');
                    $('.cart.item.message.error div').css('max-width', width);
                }

                //minicart
                $('.counter.empty').parent().addClass('empty-dup-cart');

                $('#search').on("input", function () {
                    var dInput = this.value;
                    if (dInput.length > 0) {
                        $(".hitgroup").hide();
                    } else {
                        $(".hitgroup").show();
                    }
                });
                var windowWidthPdp = $(window).width();
                if (windowWidthPdp < 768) {
                    $('.search-result ul').on('click', 'li', function() {
                        setTimeout(function () {
                            $('.catalog-product-view .modal-popup').animate({ scrollTop: $('#stores-map').offset().top - 100 }, 'slow');
                        }, 50)
                    });
                }
                var max = 0;
                $('#sizechart-id table td').each(function () {
                    max = Math.max($(this).width(), max);
                }).width(max);
                //Size chart Horizontal View

                $(".footer-container .footer-space .collapsible .title").click(function () {
                    $(this).parent().toggleClass("open");
                });

                $(".footer-item--accordion").click(function () {
                    $(this).toggleClass('active');
                })

                $('.promocode-accordion').parent().css('background-color', '#fff');

                // ----mega menu lv 2 max 7 items per row----
                $('.mega-col-level-1 .nav-item.level1').each(function () {
                    var megaColLevel2 = $(this).find(".mega-col-level-2 .nav-item.level2");
                    var separator = $("<div class='menu-side'></div>");
                    $(megaColLevel2).each(function (i) {
                        if (i % 7 == 0) {
                            $(this).nextAll().andSelf().slice(0, 7).wrapAll(separator);
                        }
                    });
                });
                // ----mega menu lv 2 max 7 items per row ends----

                $(window).resize(function () {
                    if ($(window).width() < 801) {
                        if ($(".responsive-main-header .header.links > .customer-welcome").length) {
                            $(".additional-login-mobile").show();
                            $(".login-mobile").hide();
                            $(".additional-login-mobile-create-account").hide();
                        } else if ($(".responsive-main-header .header.links > .authorization-link").length) {
                            $(".additional-login-mobile").hide();
                            $(".login-mobile").show();
                        } else {
                            $(".additional-login-mobile-create-account").show();
                        }
                        $('.top-menu.nav-mobile').find('.active').removeClass('active');
                    } else {
                        $(".additional-login-mobile").hide();
                        $(".login-mobile").show();
                    }
                });

                var interval = setInterval(function () {
                    if ($(window).width() < 801) {
                        $('.top-menu.nav-mobile').find('.active').removeClass('active');
                        if ($(".responsive-main-header .header.links > .customer-welcome").length) {
                            $(".additional-login-mobile").show();
                            $(".login-mobile").hide();
                            $(".additional-login-mobile-create-account").hide();
                            clearInterval(interval);
                        } else if ($(".responsive-main-header .header.links > .authorization-link").length) {
                            $(".additional-login-mobile").hide();
                            $(".login-mobile").show();
                            clearInterval(interval);
                        } else {
                            $(".additional-login-mobile-create-account").show();
                        }
                    } else {
                        $(".additional-login-mobile").hide();
                        $(".login-mobile").show();
                        clearInterval(interval);
                    }
                }, 1000);
            });

            $('.cel-ac-icon-cancel').on('click', function () {
                $('[data-role="minisearch-label"]').removeClass('search-active');
                $('.minisearch').removeClass('search-active');
            });


            //Faq Page Email url changes starts Here
            $(document).ready(function () {
                setTimeout(function () {
                    var url = window.location.href;
                    var page = url.substring(url.lastIndexOf('/') + 1);
                    if (page == 'faq#payment') {
                        $('#payment .togglet').addClass('toggleta');
                        $('#payment .togglec').css('display', 'block');
                        console.log("FAQ" + page);
                        if ($(window).width() < 768) {
                            $('html, body').animate({
                                scrollTop: $("#payment").offset().top - 100
                            }, 2000);
                        }
                        if ($(window).width() > 767) {
                            $('html, body').animate({
                                scrollTop: $("#payment").offset().top - 150
                            }, 2000);
                        }
                    }
                }, 1500);
            });
            //Faq Page Email url changes Ends Here
            // ----recent blog----
            if ($(window).width() < 768) {
                $(".blog-widget-recent").addClass("mobile-carousel");

                var blog_recent = $('.blog-widget-recent.mobile-carousel .post-list');

                blog_recent.owlCarousel({
                    items: 4,
                    slideSpeed: 800,
                    nav: true,
                    dots: false,
                    loop: true,
                    responsive: {
                        // breakpoint from 0 up
                        0: {
                            items: 1,
                            nav: false,
                            dots: false
                        },
                        // breakpoint from 481 up
                        480: {
                            items: 2,
                            nav: false,
                            dots: false
                        },
                        // breakpoint from 481 up
                        640: {
                            items: 3,
                            nav: false,
                            dots: false
                        }
                    }
                });
            }
            // ----recent blog----
            // Minicart click event redirect to cart page
            $("#showcart-action").click(function () {
                window.location.href = $(this).attr('href');
            });

            //size-chart starts here---------
            $(document).ready(function () {
                // Store current URL hash.
                var hash = window.location.hash.replace("#", "");

                /* Tabs ------------------------------------------------------------------------------------------------------------ */
                var $tabs = $(".js-tabs"),
                    $body = $("body");

                if ($tabs.length) {

                    var $tab_list = $tabs.find(".js-tablist");
                    $tab_list.each(function () {
                        var $this_tab_list = $(this),
                            options = $this_tab_list.data(),
                            $tabs_prefix_classes = typeof options.tabsPrefixClass !== 'undefined' ? options.tabsPrefixClass + '-' : '',
                            $hx = typeof options.hx !== 'undefined' ? options.hx : '',
                            $existing_hx = typeof options.existingHx !== 'undefined' ? options.existingHx : '',
                            $this_tab_list_items = $this_tab_list.children(".js-tablist__item"),
                            $this_tab_list_links = $this_tab_list.find(".js-tablist__link");

                        // roles init
                        $this_tab_list.attr("role", "tablist"); // ul
                        $this_tab_list_items.attr("role", "presentation"); // li
                        $this_tab_list_links.attr("role", "tab"); // a

                        // classes init
                        $this_tab_list.addClass($tabs_prefix_classes + 'tabs__list');
                        $this_tab_list_items.addClass($tabs_prefix_classes + 'tabs__item');
                        $this_tab_list_links.addClass($tabs_prefix_classes + 'tabs__link');

                        // controls/tabindex attributes
                        $this_tab_list_links.each(function () {
                            var $this = $(this),
                                $hx_generated_class = typeof options.tabsGeneratedHxClass !== 'undefined' ? options.tabsGeneratedHxClass : 'invisible',
                                $href = $this.attr("href"),
                                $controls = $($href),
                                $text = $this.text();

                            if ($hx !== "") {
                                $controls.prepend('<' + $hx + ' class="' + $hx_generated_class + '" tabindex="0">' + $text + '</' + $hx + '>');
                            }
                            if ($existing_hx !== "") {
                                $controls.find($existing_hx + ':first-child').attr('tabindex', 0);
                            }
                            if (typeof $href !== "undefined" && $href !== "" && $href !== "#") {
                                $this.attr({
                                    "aria-controls": $href.replace("#", ""),
                                    "tabindex": -1,
                                    "aria-selected": "false"
                                });
                            }

                            $this.removeAttr("href");

                        });
                    });

                    /* Tabs content ---------------------------------------------------------------------------------------------------- */
                    $(".js-tabcontent").attr({
                        "role": "tabpanel", // contents
                        "aria-hidden": "true" // all hidden
                        //"tabindex": 0
                    })
                        .each(function () {
                            var $this = $(this),
                                $this_id = $this.attr("id"),
                                $prefix_attribute = $("#label_" + $this_id).closest('.js-tablist').attr('data-tabs-prefix-class'),
                                $tabs_prefix_classes = typeof $prefix_attribute !== 'undefined' ? $prefix_attribute + '-' : '';
                            // label by link
                            $this.attr("aria-labelledby", "label_" + $this_id);

                            $this.addClass($tabs_prefix_classes + 'tabs__content');
                        });

                    // search if hash is ON not disabled tab
                    if (hash !== "" && $("#" + hash + ".js-tabcontent").length !== 0) {
                        if ($("#label_" + hash + ".js-tablist__link:not([aria-disabled='true'])").length) {
                            // display not disabled
                            $("#" + hash + ".js-tabcontent").removeAttr("aria-hidden");
                            // selection menu
                            $("#label_" + hash + ".js-tablist__link").attr({
                                "aria-selected": "true",
                                "tabindex": 0
                            });
                        }

                    }
                    // search if hash is IN not disabled tab
                    if (hash !== "" && $("#" + hash).parents('.js-tabcontent').length) {
                        var $this_hash = $("#" + hash),
                            $tab_content_parent = $this_hash.parents('.js-tabcontent'),
                            $tab_content_parent_id = $tab_content_parent.attr('id');

                        if ($("#label_" + $tab_content_parent_id + ".js-tablist__link:not([aria-disabled='true'])").length) {
                            $tab_content_parent.removeAttr("aria-hidden");
                            // selection menu
                            $("#label_" + $tab_content_parent_id + ".js-tablist__link").attr({
                                "aria-selected": "true",
                                "tabindex": 0
                            });
                        }
                    }

                    // search if data-selected="1" is on a not disabled tab for each tab system
                    $tabs.each(function () {
                        var $this = $(this),
                            $tab_selected = $this.find('.js-tablist__link[aria-selected="true"]'),
                            $tab_data_selected = $this.find('.js-tablist__link[data-selected="1"]:not([aria-disabled="true"]):first'),
                            $tab_data_selected_content = $('#' + $tab_data_selected.attr('aria-controls'));

                        if ($tab_selected.length === 0 && $tab_data_selected.length !== 0) {
                            $tab_data_selected.attr({
                                "aria-selected": "true",
                                "tabindex": 0
                            });
                            $tab_data_selected_content.removeAttr("aria-hidden");
                        }
                    });

                    // if no selected => select first not disabled
                    $tabs.each(function () {
                        var $this = $(this),
                            $tab_selected = $this.find('.js-tablist__link[aria-selected="true"]'),
                            $first_link = $this.find('.js-tablist__link:not([aria-disabled="true"]):first'),
                            $first_content = $('#' + $first_link.attr('aria-controls'));

                        if ($tab_selected.length === 0) {
                            $first_link.attr({
                                "aria-selected": "true",
                                "tabindex": 0
                            });
                            $first_content.removeAttr("aria-hidden");
                        }
                    });

                    /* Events ---------------------------------------------------------------------------------------------------------- */
                    /* click on a tab link */
                    $body.on("click", ".js-tablist__link[aria-disabled='true']", function () {
                        return false;
                    });
                    $body.on("click", ".js-tablist__link:not([aria-disabled='true'])", function (event) {
                        var $this = $(this),
                            $hash_to_update = $this.attr("aria-controls"),
                            $tab_content_linked = $("#" + $this.attr("aria-controls")),
                            $parent = $this.closest(".js-tabs"),
                            options = $parent.data(),
                            tabs_disable_fragments = typeof options.tabsDisableFragment !== 'undefined' ? true : false,
                            $all_tab_links = $parent.find("> .js-tablist > .js-tablist__item > .js-tablist__link"),
                            $all_tab_contents = $parent.find("> .js-tabcontent");

                        // aria selected false on all links
                        $all_tab_links.attr({
                            "tabindex": -1,
                            "aria-selected": "false"
                        });

                        // add aria selected on $this
                        $this.attr({
                            "aria-selected": "true",
                            "tabindex": 0
                        });

                        // add aria-hidden on all tabs contents
                        $all_tab_contents.attr("aria-hidden", "true");

                        // remove aria-hidden on tab linked
                        $tab_content_linked.removeAttr("aria-hidden");

                        // add fragment (timeout for transitions)
                        if (tabs_disable_fragments === false) {
                            setTimeout(function () {
                                history.pushState(null, null, location.pathname + location.search + '#' + $hash_to_update)
                            }, 1000);
                        }

                        event.preventDefault();
                    })

                        /* click on a tab link */
                        .on("click", ".js-link-to-tab", function () {
                            var $this = $(this),
                                $tab_to_go = $($this.attr('href')),
                                $button_to_click = $('#' + $tab_to_go.attr('aria-labelledby'));

                            if ($button_to_click.attr('aria-disabled') !== 'true') {
                                // activate tabs
                                $button_to_click.click();
                                // give focus to the good button
                                setTimeout(function () {
                                    $button_to_click.focus()
                                }, 10);
                            }

                        });

                }
                $('#id_firsty .inch-btn, #id_firsty2 .inch-btn, #id_firsty3 .inch-btn, #id_firsty4 .inch-btn').on('click', function () {
                    $(this).addClass('active');
                    $(this).siblings('.cm-btn').removeClass('active');
                    var parent = $(this).closest('.size-guide__size-chart-header');
                    var sibling = parent.siblings().closest('.size-guide__size-chart-body-inch');
                    sibling.addClass('show-table');
                    $('.size-guide__size-chart-body-cm').removeClass('show-table');
                });
                $('#id_firsty .cm-btn,  #id_firsty2 .cm-btn,  #id_firsty3 .cm-btn, #id_firsty4 .cm-btn').on('click', function () {
                    $(this).addClass('active');
                    $(this).siblings('.inch-btn').removeClass('active');
                    var parent1 = $(this).closest('.size-guide__size-chart-header');
                    var sibling1 = parent1.siblings().closest('.size-guide__size-chart-body-cm');
                    sibling1.addClass('show-table');
                    $('.size-guide__size-chart-body-inch').removeClass('show-table');

                });

                $('.inch-btn').on('click', function () {
                    $(this).addClass('active');
                    $(this).siblings('.cm-btn').removeClass('active');
                    var parent = $(this).closest('.row');
                    var sibling = parent.siblings().children('.inch-table');
                    sibling.addClass('show-table');
                    var sibling1 = parent.siblings().children('.cm-table');
                    sibling1.removeClass('show-table');
                });
                $('.cm-btn').on('click', function () {
                    $(this).addClass('active');
                    $(this).siblings('.inch-btn').removeClass('active');
                    var parent = $(this).closest('.row');
                    var sibling = parent.siblings().children('.cm-table');
                    sibling.addClass('show-table');
                    var sibling1 = parent.siblings().children('.inch-table');
                    sibling1.removeClass('show-table');
                });
                $(document).on('click', 'a[href^="#"]', function (e) {
                    // target element id
                    var id = $(this).attr('href');

                    // target element
                    var $id = $(id);
                    if ($id.length === 0) {
                        return;
                    }

                    // prevent standard hash navigation (avoid blinking in IE)
                    e.preventDefault();

                    // top position relative to the document
                    var pos = $id.offset().top - 150;

                    // animated top scrolling
                    $('body, html').animate({ scrollTop: pos });
                });
                var allCells = $(".js-tabs table td, .js-tabs table th");

                allCells
                    .on("mouseover", function () {
                        var el = $(this),
                            pos = el.index();
                        console.log(pos);
                        el.addClass('current-ele-hover');
                        el.closest('table').addClass("current-table");
                        el.parent().find("th, td").addClass("sibling-hover");
                        console.log("table" + el.parent().find("th, td"));
                        allCells.filter(":nth-child(" + (pos + 1) + ")").addClass("sibling-hover");
                        $(this).closest('td,th').nextAll().removeClass("sibling-hover");
                        $(this).closest('tr').nextAll().find('td').removeClass("sibling-hover");
                    })
                    .on("mouseout", function () {
                        allCells.removeClass("sibling-hover");
                        $(this).removeClass('current-ele-hover');
                        $('table').removeClass("current-table");
                    });
            });

        },

    });

    return $.planetsports.main;

});

